import { findJobCategoriesByJobTypeShortCodes, getJobCategoryLocaleKey } from '../libs/mapping/jobType'
import { findRegionsByDistrictShortCodes, getDistrictRegionLocaleKey } from '../libs/mapping/district'
import { getEmploymentTypeLocaleKey, sortEmploymentTypeNames } from '../libs/mapping/employmentType'
import { getParamSearchPath } from '../libs/mapping/searchParam'
import { isLatLngValid } from '../libs/location'

export default {
  methods: {
    /**
     * @param {string} companyName
     * @param {string} companyId
     * @returns {Array}
     */
    companyToBreadcrumb(companyName, companyId, eventSource) {
      if (companyName && companyId) {
        return [
          {
            newTab: true,
            path: `/company/${encodeURIComponent(companyName)}/${companyId}`,
            query: { source: eventSource },
            title: companyName,
          },
        ]
      } else {
        return []
      }
    },
    /**
     * Map district Short Code into breadcrumbs
     * @param {[string]} districtShortCodes
     * @param {string} eventSource
     * @param {object} config
     * @returns {Array}
     */
    districtToBreadcrumb(districtShortCodes, eventSource, config = {}) {
      return findRegionsByDistrictShortCodes(districtShortCodes).map(({ districts, region }) => ({
        newTab: true,
        path: config.path
          ? config.path
          : getParamSearchPath({ district: districts.map((d) => d.shortCode) }, this.currentLocale.code),
        query: config.query ? { source: eventSource, ...config.query } : { source: eventSource },
        title: this.$t(getDistrictRegionLocaleKey(region)),
      }))
    },

    /**
     * Map employment type names into breadcrumbs
     * @param {[string]} employmentTypes
     * @param {string} eventSource
     * @param {object} config
     * @returns {Array}
     */
    employmentToBreadcrumb(employmentTypes, eventSource, config = {}) {
      if (Array.isArray(employmentTypes)) {
        return sortEmploymentTypeNames(employmentTypes).map((employment) => ({
          newTab: true,
          path: config.path ? config.path : getParamSearchPath({ employment: [employment] }, this.currentLocale.code),
          query: config.query ? { source: eventSource, ...config.query } : { source: eventSource },
          title: this.$t(getEmploymentTypeLocaleKey(employment)),
        }))
      }
      return []
    },

    /**
     * Map job type short codes into breadcrumbs
     * @param {[string]} jobTypeShortCodes
     * @param {string} eventSource
     * @param {object} config
     * @returns {Array}
     */
    jobTypeToBreadcrumb(jobTypeShortCodes, eventSource, config = {}) {
      return findJobCategoriesByJobTypeShortCodes(jobTypeShortCodes).map(({ category, jobTypes }) => ({
        newTab: true,
        path: config.path
          ? config.path
          : getParamSearchPath(
              { jobType: jobTypes.map((jt) => jt.shortCode).filter((sc) => sc) },
              this.currentLocale.code,
            ),
        query: config.query ? { source: eventSource, ...config.query } : { source: eventSource },
        title: this.$t(getJobCategoryLocaleKey(category)),
      }))
    },

    /**
     * @param latitude
     * @param longitude
     * @returns {*[]|{path: string, title: VueI18n.TranslateResult}[]}
     */
    nearbyToBreadcrumb(lat, lng, eventSource) {
      if (isLatLngValid(lat, lng)) {
        return [
          {
            newTab: true,
            path: `/find-jobs`,
            query: {
              latitude: lat,
              longitude: lng,
              source: eventSource,
            },
            title: this.$t('jobCategory.nearby'),
          },
        ]
      } else {
        return []
      }
    },
  },
}
